import Link from '@components/v2/ui/Link/Link';
import Typography from '@components/v2/ui/Typography/Typography';
import { privacyPoliticsUrl, termsOfUseUrl } from '../../../../../../components/PrivacyPolitics';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import useTermsAgreementStyles from './termsAgreement.styles';

const TermsAgreement = () => {
  const { classes } = useTermsAgreementStyles();
  const { translate } = useTranslation();

  return (
    <Typography variant="body2" color="text.secondary" align="center" className={classes.terms}>
      {translate(LangEnum.LOGIN_TERMS_AGREEMENT_PREFIX)}
      <Link href={termsOfUseUrl} color="text.primary">
        {translate(LangEnum.LOGIN_TERMS_OF_USE)}
      </Link>
      {translate(LangEnum.LOGIN_TERMS_AGREEMENT_CONNECTOR)}
      <Link href={privacyPoliticsUrl} color="text.primary">
        {translate(LangEnum.LOGIN_PRIVACY_POLICY)}
      </Link>
      {translate(LangEnum.LOGIN_TERMS_AGREEMENT_SUFFIX)}
    </Typography>
  );
};

export default TermsAgreement;
